import { connect } from 'react-redux';
import storage from 'app/services/storage';
import informationModule from 'app/store/information';
import Competition from './CompetitionDetail.component';

const {
  bonusCardInfoRequest,
  setBonusCardInfoContent,
  competitionsRequest,
  sliderContentRequest,
  sendQuestionFormData,
  competitionsDetailRequest,
  competitionEventsRequest
} = informationModule.actions;

const mapStateToProps = ({ information, layout, user }) => ({
  content: information.bonusCardInfo,
  isLoading: layout.isLoading,
  formOutput: information.data,
  isSubmitted: information.competitions_detail,
  isLoggedIn: !!user.user,
  legalInfo: information.legalInfoContent,
  film: information.slider,
  competitionEvents: information.competitionEvents,
  location: storage.getLocation()
});

const mapDispatchToProps = {
  fetchCompetitionDetailById: competitionsDetailRequest,
  fetchCompetitionContent: competitionsRequest,
  fetchSliderContent: sliderContentRequest,
  sendFormData: sendQuestionFormData,
  fetchContent: bonusCardInfoRequest,
  getCompetitionEvents: competitionEventsRequest,
  clearState: setBonusCardInfoContent.bind(null, null)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Competition);
